import { i18n } from '@/plugins/internationalization/i18n';

export type ChartTime = {
    dateFormat: (format: string, timestamp: number) => string;
};

// The ISO week comes from Highcharts' configured formatter, keeping the tooltip aligned with the
// axis. The human-facing word and calendar date/time remain localized through vue-i18n.
//
// timestamps here are farm-local buckets (day boundaries chosen in the farm's own timezone), not
// UTC instants. Force `timeZone: 'UTC'` so vue-i18n's Intl formatter renders each bucket in the
// same timezone it was cut in, instead of reinterpreting it in the viewer's browser timezone.
//
// Shared by Active groups' own charts and the production-group timeline chart - one tooltip-header
// format for every chart plotting these farm-local buckets, not one per page.
export function formatChartTooltipHeader(timestamp: number, time?: ChartTime, includeTime = false): string {
    const parts = [i18n.global.d(timestamp, { key: 'middle', timeZone: 'UTC' }) as string];
    if (includeTime) parts.push(i18n.global.d(timestamp, { key: 'clock', timeZone: 'UTC' }) as string);
    const week = time?.dateFormat('%W', timestamp);
    if (week) parts.push(`${i18n.global.t('views.monitoring.activeGroups.texts.week')} ${week}`);
    return parts.join(' · ');
}
